/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ArticleDto { 
    idArticle?: number;
    refNo?: string;
    name?: string;
    articleType?: ArticleDto.ArticleTypeEnum;
}
export namespace ArticleDto {
    export const ArticleTypeEnum = {
        TrapTransmitter: 'TRAP_TRANSMITTER',
        ExternalDropOff: 'EXTERNAL_DROP_OFF',
        BatteryOption: 'BATTERY_OPTION',
        BeltOption: 'BELT_OPTION',
        CollarOption: 'COLLAR_OPTION',
        InternalDropOff: 'INTERNAL_DROP_OFF',
        BatterySize: 'BATTERY_SIZE',
        ComType: 'COM_TYPE',
        CollarClass: 'COLLAR_CLASS',
        NoConfigType: 'NO_CONFIG_TYPE'
    } as const;
    export type ArticleTypeEnum = typeof ArticleTypeEnum[keyof typeof ArticleTypeEnum];
}


export type ArticleTypeEnum = typeof ArticleDto.ArticleTypeEnum[keyof typeof ArticleDto.ArticleTypeEnum];
